/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { EligibilityCheckProviderInfo } from './EligibilityCheckProviderInfo';
import {
    EligibilityCheckProviderInfoFromJSON,
    EligibilityCheckProviderInfoFromJSONTyped,
    EligibilityCheckProviderInfoToJSON,
} from './EligibilityCheckProviderInfo';
import type { EligibilityRequestAltParamsInner } from './EligibilityRequestAltParamsInner';
import {
    EligibilityRequestAltParamsInnerFromJSON,
    EligibilityRequestAltParamsInnerFromJSONTyped,
    EligibilityRequestAltParamsInnerToJSON,
} from './EligibilityRequestAltParamsInner';
import type { EligibilityRequestServiceTypeCodes } from './EligibilityRequestServiceTypeCodes';
import {
    EligibilityRequestServiceTypeCodesFromJSON,
    EligibilityRequestServiceTypeCodesFromJSONTyped,
    EligibilityRequestServiceTypeCodesToJSON,
} from './EligibilityRequestServiceTypeCodes';
import type { ServiceDates } from './ServiceDates';
import {
    ServiceDatesFromJSON,
    ServiceDatesFromJSONTyped,
    ServiceDatesToJSON,
} from './ServiceDates';
import type { SubscriberInfo } from './SubscriberInfo';
import {
    SubscriberInfoFromJSON,
    SubscriberInfoFromJSONTyped,
    SubscriberInfoToJSON,
} from './SubscriberInfo';

/**
 * 
 * @export
 * @interface EligibilityCheckRequestObject
 */
export interface EligibilityCheckRequestObject {
    /**
     * 
     * @type {EligibilityCheckProviderInfo}
     * @memberof EligibilityCheckRequestObject
     */
    provider?: EligibilityCheckProviderInfo;
    /**
     * 
     * @type {SubscriberInfo}
     * @memberof EligibilityCheckRequestObject
     */
    subscriber?: SubscriberInfo;
    /**
     * 
     * @type {ServiceDates}
     * @memberof EligibilityCheckRequestObject
     */
    serviceDates?: ServiceDates;
    /**
     * 
     * @type {string}
     * @memberof EligibilityCheckRequestObject
     */
    payerIdentifier?: string;
    /**
     * 
     * @type {EligibilityRequestServiceTypeCodes}
     * @memberof EligibilityCheckRequestObject
     */
    serviceTypeCodes?: EligibilityRequestServiceTypeCodes;
    /**
     * 
     * @type {Array<EligibilityRequestAltParamsInner>}
     * @memberof EligibilityCheckRequestObject
     */
    altParams?: Array<EligibilityRequestAltParamsInner>;
}

/**
 * Check if a given object implements the EligibilityCheckRequestObject interface.
 */
export function instanceOfEligibilityCheckRequestObject(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function EligibilityCheckRequestObjectFromJSON(json: any): EligibilityCheckRequestObject {
    return EligibilityCheckRequestObjectFromJSONTyped(json, false);
}

export function EligibilityCheckRequestObjectFromJSONTyped(json: any, ignoreDiscriminator: boolean): EligibilityCheckRequestObject {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'provider': !exists(json, 'provider') ? undefined : EligibilityCheckProviderInfoFromJSON(json['provider']),
        'subscriber': !exists(json, 'subscriber') ? undefined : SubscriberInfoFromJSON(json['subscriber']),
        'serviceDates': !exists(json, 'serviceDates') ? undefined : ServiceDatesFromJSON(json['serviceDates']),
        'payerIdentifier': !exists(json, 'payerIdentifier') ? undefined : json['payerIdentifier'],
        'serviceTypeCodes': !exists(json, 'serviceTypeCodes') ? undefined : EligibilityRequestServiceTypeCodesFromJSON(json['serviceTypeCodes']),
        'altParams': !exists(json, 'altParams') ? undefined : ((json['altParams'] as Array<any>).map(EligibilityRequestAltParamsInnerFromJSON)),
    };
}

export function EligibilityCheckRequestObjectToJSON(value?: EligibilityCheckRequestObject | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'provider': EligibilityCheckProviderInfoToJSON(value.provider),
        'subscriber': SubscriberInfoToJSON(value.subscriber),
        'serviceDates': ServiceDatesToJSON(value.serviceDates),
        'payerIdentifier': value.payerIdentifier,
        'serviceTypeCodes': EligibilityRequestServiceTypeCodesToJSON(value.serviceTypeCodes),
        'altParams': value.altParams === undefined ? undefined : ((value.altParams as Array<any>).map(EligibilityRequestAltParamsInnerToJSON)),
    };
}

